import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

// Product List Components
import Checkout0 from "./Checkout0";
import Checkout1 from "./Checkout1";


const Checkout = () => {
  const [cartNo, setCartNo] = useState(null);
  const [data, setData] = useState([]);

  const user_auto_id = sessionStorage.getItem("accessToken");

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setCartNo(parseInt(parsedStyle.cart_layout_no));
    }
  }, []);

  const fetchCartList = async () => {
    try {
      setData([]);
      const formData = new FormData();
      formData.append("user_auto_id", user_auto_id);
      formData.append("admin_auto_id", sessionStorage.getItem("admin_auto_id"));
      formData.append("limit", "10");
      formData.append("page_number", "1");
      formData.append("app_type_id", sessionStorage.getItem("app_type_id"));
      formData.append("pincode", "411045");

      const response = await axios.post(
        "https://gruzen.in/GrobizEcommerceAppBuilder/api/get_cart_list",
        formData
      );

      if (response.data.status === 1) {
        const { status, ...restData } = response.data;
        setData(restData);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    fetchCartList();
  }, [user_auto_id]);

  // Mapping cartNo to Components
  const checkoutComponents = {
    0: Checkout0,
    1: Checkout1,
  };

  const SelectedCheckout = checkoutComponents[cartNo];

  return (
    <div>
      {SelectedCheckout && (
        <SelectedCheckout data={data} />
      )}
    </div>
  );
};

export default Checkout;
